import DropzoneActiveOverlay from './DropzoneActiveOverlay.component';

export default DropzoneActiveOverlay;
